import React from 'react'

import Loadable from 'react-loadable';
import ReactLoading from 'react-loading';

import Home from './components/home'
import Signup from './components/signup'
import ForgotPassword from './components/auth/forgotpass'
import ForgotPasswordVerification from './components/auth/forgotpassotp'
import ResetPassword from './components/auth/resetpassword'
import SignupVerification from './components/auth/signupotp'
import Login from './components/login'
import Logout from './components/logout'
import Dashboard from './components/dashboard'
import StockItems from './components/stockitem/stockitemlist'
import AddStockItem from './components/stockitem/addstockitem'
import Suppliers from './components/supplier/supplierlist'
import AddSupplier from './components/supplier/addsuppliernew'
import EditSupplier from './components/supplier/addsuppliernew'
import EditStockItem from './components/stockitem/editstockitem'
import AddClient from './components/client/addclientnew'
import Clients from './components/client/clientlistnew'
import Items from './components/item/itemlist'
import EditItem from './components/item/edititemnew'
import AddService from './components/item/addservice'
import Services from './components/item/servicelist'
import Invoices from './components/invoice/invoicelist2'
import AddInvoice from './components/invoice/invoiceselect'
import PreviewInvoice from './components/invoice/previewinvoice'
import EditCompanyProfile from './components/profile/editprofile'
import EditSettings from './components/profile/editsettings'
import Billing from './components/profile/billing'
import AddDiscount from './components/discount/adddiscount'
import Discounts from './components/discount/discountlist'
import Units from './components/unit/unitlist'
import AddUnit from './components/unit/addunit'
import Gsts from './components/gst/gstlist'
import AddGst from './components/gst/addgst'
import Purchases from './components/purchase/purchaselist'
import AddPurchase from './components/purchase/purchaseselect'
import PreviewPurchase from './components/purchase/previewpurchase'
import Returns from './components/credit/creditlist'
import AddReturn from './components/credit/creditselect'
import AddGeneralCredit from './components/generalnote/addgeneralcredit'
import PreviewCredit from './components/credit/previewcredit'
import PreviewGeneralCredit from './components/generalnote/previewgeneralcredit'
import Preturns from './components/debit/debitlist'
import AddPreturn from './components/debit/debitselect'
import AddGeneralDebit from './components/generalnote/addgeneraldebit'
import PreviewDebit from './components/debit/previewdebit'
import AddBrand from './components/brand/addbrand'
import AddExpense from './components/expense/addexpense'
import Expenses from './components/expense/expenselist'
import Brands from './components/brand/brandlist'
import Daybook from './components/report/daylog'
import Reports from './components/report/reports'
import BrandSalesSummary from './components/report/brandsalesummary'
import ItemByBrandSalesSummary from './components/report/itembybrandsalesummary'
import ItemSalesSummary from './components/report/itemsalesummary'
import ClientSalesSummary from './components/report/clientsalesummary'
import SupplierPurchasesSummary from './components/report/supplierpurchasessummary'
import AddReceipt from './components/receipt/addreceipt'
import Receipts from './components/receipt/receiptlist'
import AddPayment from './components/payment/addpayment'
import Payments from './components/payment/paymentlist'
import Developments from './components/blog/developments'

const Loading = ({ type, color }) => (
    <ReactLoading type={'spin'} color={'#77A4F1'} height={64} width={64} className='component-loading' />
);


class NotFound extends React.Component {
  constructor(props) {
    super(props)
    document.title = "URL Not Found"
  }
  render() {
    return <p className="text-danger">Not Found URL <a href="/" className="btn btn-info">GO HOME</a></p>
  }
}

const ShortLinkView = Loadable({
  loader: () => import('./components/shortlink/view'),
  loading: Loading,
});

const DepartmentList = Loadable({
  loader: () => import('./components/department/departmentlist'),
  loading: Loading,
})
const DepartmentCreateOrEdit = Loadable({
  loader: () => import('./components/department/adddepartment'),
  loading: Loading,
})

const routes = [
  {
    path: '/share',
    component: ShortLinkView
  },
  {
    path: '/',
    exact: true,
    component: Home
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/signup',
    component: Signup
  },
  {
    path: '/verify_phone',
    component: SignupVerification
  },

  {
    path:'/forgot_password',
    component: ForgotPassword
  },
  {
    path:'/verify_forgot_pass_otp',
    component: ForgotPasswordVerification
  },
  {
    path:'/update_password',
    component: ResetPassword
  },

  {
    component: NotFound
  }
]

export const appRoutes= [
  {
    path: '/share',
    component: ShortLinkView
  },

  {
    path: '/changes/',
    exact: true,
    component: Developments
  },

  {
    path: '/',
    exact: true,
    component: Dashboard
  },
  {
    path: '/logout',
    exact: true,
    component: Logout
  },
  {
    path: '/create',
    component: AddStockItem
  },
  {
    path: '/stock_items',
    exact: true,
    component: StockItems
  },
  {
    path: '/stock_items/create',
    component: AddStockItem
  },
  {
    path: '/stock_items/edit/:stock_item_id',
    component: EditStockItem
  },
  {
    path: '/suppliers/create',
    component: AddSupplier
  },
  {
    path: '/suppliers/edit/:supplier_id',
    component: EditSupplier
  },
  {
    path: '/suppliers',
    component: Suppliers
  },
  { path: '/clients/create', component: AddClient },
  { path: '/clients/edit/:client_id', component: AddClient},
  { path: '/clients', component: Clients },

  { path: '/costcenters/create', component: DepartmentCreateOrEdit },
  { path: '/costcenters/edit/:department_id', component: DepartmentCreateOrEdit},
  { path: '/costcenters', component: DepartmentList },

  { path: '/items/create', component: EditItem },
  { path: '/items/edit/:item_id', component: EditItem},
  { path: '/items', component: Items },

  { path: '/services/create', component: AddService },
  { path: '/services/edit/:item_id', component: AddService},
  { path: '/services', component: Services },

  //
  // { path: '/invoices/type_batch/create', component: BatchInvoice },
  // { path: '/invoices/type_batch/edit/:invoice_id', component: BatchInvoice },

  { path: '/invoices/create', component: AddInvoice },
  { path: '/invoices/edit/:invoice_id/receipts', component: Receipts},
  { path: '/invoices/edit/:invoice_id', component: AddInvoice},
  { path: '/invoices/preview/:invoice_id', component: PreviewInvoice},
  { path: '/invoices', component: Invoices },

  { path: '/receipts/create', component: AddReceipt },
  { path: '/receipts', component: Receipts },

  { path: '/purchases/create', component: AddPurchase },
  { path: '/purchases/edit/:purchase_id', component: AddPurchase},
  { path: '/purchases/preview/:purchase_id', component: PreviewPurchase},
  { path: '/purchases/', component: Purchases },

  { path: '/payments/create', component: AddPayment },
  { path: '/payments', component: Payments },

  { path: '/credit_notes/create', component: AddReturn },
  { path: '/credit_notes/edit/:retn_id', component: AddReturn},
  { path: '/credit_notes/preview/:retn_id', component: PreviewCredit},

  { path: '/general_credit_notes/create', component: AddGeneralCredit },
  { path: '/general_credit_notes/edit/:generalnote_id', component: AddGeneralCredit},
  { path: '/general_credit_notes/preview/:retn_id', component: PreviewGeneralCredit},

  { path: '/credit_notes/', component: Returns },

  { path: '/debit_notes/create', component: AddPreturn },
  { path: '/debit_notes/edit/:pretn_id', component: AddPreturn},
  { path: '/debit_notes/preview/:pretn_id', component: PreviewDebit},

  { path: '/general_debit_notes/create', component: AddGeneralDebit },
  { path: '/general_debit_notes/edit/:generalnote_id', component: AddGeneralDebit},

  { path: '/debit_notes/', component: Preturns },

  { path: '/discounts/create', component: AddDiscount },
  { path: '/discounts/edit/:discount_id', component: AddDiscount},
  { path: '/discounts', component: Discounts },

  { path: '/units/create', component: AddUnit },
  { path: '/units/edit/:unit_id', component: AddUnit},
  { path: '/units', component: Units },

  { path: '/gsts/create', component: AddGst },
  { path: '/gsts/edit/:gst_id', component: AddGst},
  { path: '/gsts', component: Gsts },

  { path: '/reports/day_book', component: Daybook},
  // { path: '/reports/gstr_1', component: Gstr1},
  // { path: '/reports/gstr_3b', component: Gstr3b},
  { path: '/reports/brand_sale_report', component: BrandSalesSummary},
  { path: '/reports/items_sale_report/:brand_id', component: ItemByBrandSalesSummary},
  { path: '/reports/item_sale_report/:item_id', component: ItemSalesSummary },

  { path: '/reports/clients_invoice_report', component: ClientSalesSummary },
  { path: '/reports/suppliers_purchase_report', component: SupplierPurchasesSummary },
  { path: '/reports/gstr_reports', component: Reports },

  { path: '/brands/create', component: AddBrand},
  { path: '/brands/edit/:brand_id', component: AddBrand},
  { path: '/brands', component: Brands},

  { path: '/expenses/create', component: AddExpense},
  { path: '/expenses/edit/:expense_id', component: AddExpense},
  { path: '/expenses', component: Expenses},

  { path: '/edit_company_profile', component: EditCompanyProfile},
  { path: '/edit_settings', component: EditSettings},
  { path: '/billing', component: Billing},


  { component: NotFound }
]

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js